import { z } from 'zod';

export const TraderPermission = z.enum(['PAYOUTS', 'WITHDRAW']);

export const TraderRole = z.enum(['ADMIN', 'OWNER', 'TRADER']);
export type TraderRole = z.infer<typeof TraderRole>;

export const Trader = z.object({
  id: z.string(),
  companyId: z.string(),
  companyName: z.string(),
  name: z.string(),
  role: TraderRole,
  permissions: z.preprocess((permissions) => {
    if (Array.isArray(permissions)) return new Set(permissions);
    return permissions;
  }, z.set(TraderPermission)),
  email: z.string(),
  locked: z.boolean(),
  credentialsPriority: z.number(),
  insertedAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});
export type Trader = z.infer<typeof Trader>;

export const TraderBalance = z.object({
  amount: z.string(),
  currency: z.string(),
});

export const TraderBalances = z.object({
  frozenBalance: TraderBalance,
  balance: TraderBalance,
  securityDeposit: TraderBalance,
});
export type TraderBalances = z.infer<typeof TraderBalances>;

export const TraderFilterDetails = Trader.pick({
  id: true,
  name: true,
  email: true,
  role: true,
});
export type TraderFilterDetails = z.infer<typeof TraderFilterDetails>;
